import { OutputHTMLElement } from "components/output/baseHTMLElementOutput";
import { Tooltip } from "components/components/tooltip/tooltip";
import { EnumDateInputType } from "components/input/dateFormats";
import moment from "moment";
import template from "./timeInputOutput.hbs";
import IMask from "imask";
import { IMaskDateblocks } from "components/input/imaskDateBlocks";

export class TimeOutputElement extends OutputHTMLElement {

  private mask: IMask.InputMask<IMask.MaskedRange>;
  private seconds: boolean = false;

  constructor() {
    super();

    this.seconds = (this.getAttribute("seconds") === 'true');

    const optTemplate = {
      "prefixId": "to",
      "id": this.getAttribute("_id"),
      "className": "c-time-input__input o-form-component__input  o-form-component__input-group__input",
      "style": this.getAttribute("_style"),
      "disableFocusKeyboard": (this.getAttribute("disableFocusKeyboard") === 'true'),
    } as any;

    if (this.seconds) {
      optTemplate.step = 1;
    }

    this.innerHTML = template(optTemplate);

    this.input = this.querySelector("input");
    this.mask = this.initMask();

    Tooltip.bindElement(this);
  }

  private initMask(): IMask.InputMask<IMask.MaskedRange> {

    const momentFormat = this.getFormatterPattern();

    const maskOptions = {
      mask: momentFormat,
      blocks: {
        HH: {
          mask: IMask.MaskedRange,
          from: IMaskDateblocks.HH.from,
          to: IMaskDateblocks.HH.to,
        },
        mm: {
          mask: IMask.MaskedRange,
          from: IMaskDateblocks.mm.from,
          to: IMaskDateblocks.mm.to,
        },
      },
    } as any;

    if (this.seconds) {
      maskOptions.blocks.ss = {
        mask: IMask.MaskedRange,
        from: IMaskDateblocks.ss.from,
        to: IMaskDateblocks.ss.to,
      };
    }

    return IMask(this.input, maskOptions);
  }

  private getFormatterPattern(): string {
    return (this.seconds) ? EnumDateInputType.getFormatterPattern(EnumDateInputType.timeSecond) : EnumDateInputType.getFormatterPattern(EnumDateInputType.time);
  }

  get data(): string {
    let tzDate = this.input.value as string;
    if (tzDate) {
      const date = moment.utc(tzDate, this.getFormatterPattern());
      if (date.isValid()) {
        return tzDate;
      }
    }
    return null;
  }

  set data(v: string) {
    this.input.value = v?.toString() ?? null;
    this.initialValue.value = this.data;
    this.mask?.updateValue();
  }

}

export function initTimeOutputWebComponent() {
  window.customElements.define("s6-time-output", TimeOutputElement);
}
